import { render, staticRenderFns } from "./user-register.component.vue?vue&type=template&id=397659f7&"
import script from "./user-register.component.ts?vue&type=script&lang=ts&"
export * from "./user-register.component.ts?vue&type=script&lang=ts&"
import style0 from "./user-register.component.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VBtn,VCard,VForm})
